import moment from "moment";
import * as XLSX from 'xlsx/xlsx.mjs';

import template from "./pUsers.html";

export function pUsersDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pUsersController,
    controllerAs: 'pUsers',
    bindToController: true
  };

  return directive;
}

class pUsersController {
  constructor(Auth, Admin, $q, bModal, $scope, $interval, Notes, $location, ConnectionQuality) {
    'ngInject';
    this.Auth = Auth;
    this.Admin = Admin;
    this.$q = $q;
    this.bModal = bModal;
    this.$scope = $scope;
    this.$interval = $interval;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.$location = $location;

    this.init();

    this.fields = {
      fullName: "name",
      emailAddress: "email",
      country: "country",
      role: "role",
      canExportWorklog: "checkbox",
      canImportIncome: "checkbox",
      canImportIncomeCountrywide: "checkbox",
      managementViewHidden: "checkbox",
      activeFrom: "validFrom"
    };

    this.blockedUsersfields = {
      fullName: "name",
      emailAddress: "email",
      country: "country",
      role: "role",
      canExportWorklog: "checkbox",
      canImportIncome: "checkbox",
      canImportIncomeCountrywide: "checkbox",
      managementViewHidden: "checkbox",
      blockedAtF: "name"
    };

    this.usersActions = [
      {
        name: "export",
        functionName: "exportActiveUsers",
        fa: "fa-download"
      }
    ];

    this.rowActions = [
      {
        name: "edit",
        functionName: "startEditingUsers"
      },
      {
        name: "view",
        functionName: "openUser",
        nonBlockable: true
      },
      {
        name: "block",
        functionName: "startBlockingUser"
      },
      {
        name: "changeTeam",
        functionName: "startChangeTeam"
      }
    ];

    this.rowActionsBlocked = [
      {
        name: "edit",
        functionName: "startEditingBlockedUser"
      },
      {
        name: "view",
        functionName: "openUser"
      },
      {
        name: "unblock",
        functionName: "confirmUnblockUser"
      }
    ];

    /*
    * b-dialog-card data
    */

    this.userData = {
      fullName: {
        type: "text"
      },
      emailAddress: {
        type: "text"
      },
      country: {
        type: "text",
        editionDisabled: true
      },
      teamId: {
        type: "select",
      },
      teamIdStatic: {
        type: "text",
        editionDisabled: true
      },
      role: {
        type: "array"
      },
      canExportWorklog: {
        type: "checkbox",
        isNotRequired: true
      },
      canImportIncome: {
        type: "checkbox",
        isNotRequired: true
      },
      canImportIncomeCountrywide: {
        type: "checkbox_reliant",
        reliantOn: "canImportIncome",
        isNotRequired: true,
        infoTooltip: true
      },
      managementViewHidden: {
        type: "checkbox",
        isNotRequired: true
      },
      activeFrom: {
        type: "text",
        editionDisabled: true
      }
    };

    this.blockUserData = {
      validFrom: {
        type: "date"
      }
    };

    this.userSelect = {
      teamId: {
        valueToAdd: "id",
        valueToShow: "name"
      },
      role: []
    };

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;

        if(this.user.isAdmin) {
          this.fields = {
            fullName: "name",
            emailAddress: "email",
            country: "country",
            role: "role",
            canEditAccepted: "checkbox",
            canExportWorklog: "checkbox",
            canImportIncome: "checkbox",
            canImportIncomeCountrywide: "checkbox",
            canViewRates: "checkbox",
            canUpdateRates: "checkbox",
            // canAccessFlexitime: "checkbox",
            managementViewHidden: "checkbox",
            isIntegrationAdmin: "checkbox",
            isLocalAdmin: "checkbox",
            isAdmin: "checkbox",
            activeFrom: "activeFrom"
          };

          this.blockedUsersfields = {
            fullName: "name",
            emailAddress: "email",
            country: "country",
            role: "role",
            canEditAccepted: "checkbox",
            canExportWorklog: "checkbox",
            canImportIncome: "checkbox",
            canImportIncomeCountrywide: "checkbox",
            canViewRates: "checkbox",
            canUpdateRates: "checkbox",
            managementViewHidden: "checkbox",
            isIntegrationAdmin: "checkbox",
            isLocalAdmin: "checkbox",
            isAdmin: "checkbox",
            blockedAtF: "name"
          };

          this.userData = {
            fullName: {
              type: "text"
            },
            emailAddress: {
              type: "text"
            },
            country: {
              type: "text",
              editionDisabled: true
            },
            teamId: {
              type: "select"
            },
            teamIdStatic: {
              type: "text",
              editionDisabled: true
            },
            role: {
              type: "array"
            },
            canEditAccepted: {
              type: "checkbox",
              isNotRequired: true
            },
            canExportWorklog: {
              type: "checkbox",
              isNotRequired: true
            },
            canImportIncome: {
              type: "checkbox",
              isNotRequired: true
            },
            canImportIncomeCountrywide: {
              type: "checkbox_reliant",
              reliantOn: "canImportIncome",
              isNotRequired: true,
              infoTooltip: true
            },
            canAccessFlexitime: {
              type: "checkbox",
              isNotRequired: true
            },
            canViewRates:{
              type: "checkbox",
              isNotRequired: true
            },
            canUpdateRates: {
              type: "checkbox_reliant",
              reliantOn: "canViewRates",
              isNotRequired: true
            },
            managementViewHidden: {
              type: "checkbox",
              isNotRequired: true
            },
            isIntegrationAdmin: {
              type: "checkbox",
              isNotRequired: true
            },
            isLocalAdmin: {
              type: "radio",
              isNotRequired: true
            },
            isAdmin: {
              type: "radio",
              isNotRequired: true
            },
            activeFrom: {
              type: "text",
              editionDisabled: true
            }
          };
        }

        let promises = [this.Admin.getUsers(), this.Admin.getTeams()];
        this.$q.all(promises).then(
          (success) => {
            var users = success[0].data.users;

            users.sort((a, b) => a.fullName.localeCompare(b.fullName));

            if(this.user.isLocalAdmin){
              this.availableRoles = success[0].data.availableRoles.filter( role => role != 'GlobalManager');
              users.forEach(u => u.blocked = u.role == "GlobalManager");
            } else {
              this.availableRoles = success[0].data.availableRoles;
            }
            this.userSelect.role = this.availableRoles;
            var tempRole = this.userSelect.role[1];
            this.userSelect.role[1] = this.userSelect.role[2];
            this.userSelect.role[2] = tempRole;
            users.forEach(u => {
              delete u.seniorityLevel;
              delete u.standardWorkingHours;
            });
            this.teams = success[1].data;
            users.forEach((u, i) => {
              var team = this.teams.find(t => t.id == u.teamId);
              if(team) {
                users[i].country = team.country;
              }
            });
            this.users = users.filter(u => !u.blockedAt);
            this.users.forEach(u => u.activeFrom = u.activeFrom && moment(u.activeFrom).format("YYYY-MM-DD"));
            this.blockedUsers = users.filter(bu => bu.blockedAt);
            this.blockedUsers.forEach(u => u.blockedAtF = moment(u.blockedAt).format("YYYY-MM-DD") );
            this.userSelect.teamId.values = this.teams;

            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  openUser(user) {
    let usersFromTeam = this.users.filter( u => u.teamId == user.teamId);
    localStorage.setItem("roedl-admin-users", angular.toJson(usersFromTeam));
    this.$location.path('/admin/countries/' + user.country + '/team/' + user.teamId + '/user/' + user.id);
  }

  startAddingUser() {
    this.addUserProcess = true;
  }

  addUser(user) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.addUser(user).then(
      () => {
        this.addUserProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  updateUser(user , process) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    if(!user.isIntegrationAdmin && this.user.isAdmin) {
      user.isIntegrationAdmin = false;
    }

    this.Admin.updateUser(user.id, user).then(
      () => {
        this[process] = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingUsers(user) {
    this.editUserProcess = true;
    this.editUserValues  = angular.fromJson(angular.toJson(user));
    delete this.userData.teamId;
    this.editUserValues.teamIdStatic = this.userSelect.teamId.values.find( v => v.id === user.teamId).name;

    if (this.user.isLocalAdmin) {
      delete this.editUserValues.canEditAccepted;
      delete this.editUserValues.isAdmin;
      delete this.editUserValues.isLocalAdmin;
      delete this.editUserValues.isIntegrationAdmin;
      delete this.editUserValues.calcGlobalBidsAccess;
      delete this.editUserValues.canViewRates;
      delete this.editUserValues.canUpdateRates;
      delete this.editUserValues.canAccess360View;
      delete this.editUserValues.canAccessFlexitime;
      delete this.editUserValues.country;
      delete this.editUserValues.worknorms;
      delete this.editUserValues.teamIdStatic;
    }

    this.userSelect.teamId.values = this.teams.filter(t => t.country == this.teams.find(t => t.id == user.teamId).country);
  }

  startChangeTeam(user) {
    this.changeTeamProcess = true;
    this.usersTeams = this.teams.filter(t => (t.country == this.teams.find(t => t.id == user.teamId).country && t.archivedAt === undefined)).map(t => { return {teamName: t.name, teamId: t.id};});
    this.usersTeams.sort((a,b) => a.teamName.localeCompare(b.teamName));
    this.usersTeams.unshift({teamName: null, teamId: null});

    this.Admin.getUsersTeam( user.id ).then(
      (success) => {
        //success - list of current and new teams witdh dates
        // [{id, userId, teamId, teamName, when},{},{}]
        this.teamData = {
          user: user,
          currentTeam: success.data[0],
          newTeam1: success.data[1] && success.data[1],
          newTeam2: success.data[2] && success.data[2]
        };

        this.editedTeamData = {
          user: user,
          data: angular.copy(this.teamData)
        };
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  changeTeamDisabled() {
    return (
      !this.editedTeamData
      || !this.editedTeamData.data.newTeam1
      || !this.editedTeamData.data.newTeam1.teamId
      || (this.editedTeamData.data.newTeam1.teamId && !this.editedTeamData.data.newTeam1.when)
      || (
        this.editedTeamData.data.newTeam2 
        && !this.editedTeamData.data.newTeam2.teamId
        && this.editedTeamData.data.newTeam2.when
      )
    );
  }

  changeTeam(editedUser) {
    this.state = "loading";

    let makeSubmit = (team) => {
      if (!this.editedTeamData.data[team] || !this.editedTeamData.data[team].teamId) {
        return null;
      }
      if(moment( this.teamData.currentTeam.when ).isAfter( moment() ) && this.editedTeamData.data[team]) {
        return this.Admin.editUsersTeam(editedUser.user.id, this.teamData.currentTeam.id, {
          teamId: editedUser.data[team].teamId,
          date: editedUser.data[team].when }
        );
      }
      if(this.teamData[team] &&
          (this.teamData[team].teamName != this.editedTeamData.data[team].teamName ||
            moment(this.teamData[team].when).format('YYYY-MM-DD') != moment(this.editedTeamData.data[team].when).format('YYYY-MM-DD'))){ //PATCH or DELETE
        if(this.editedTeamData.data[team].teamName) { //PATCH
          return this.Admin.editUsersTeam(editedUser.user.id, this.teamData[team].id, {
            teamId: editedUser.data[team].teamId,
            date: editedUser.data[team].when }
          );
        } else { //DELETE
          return this.Admin.deleteUsersTeam(editedUser.user.id, this.teamData[team].id);
        }
      } else if(!this.teamData[team] && this.editedTeamData.data[team]){ //POST
        return this.Admin.setUsersTeam(editedUser.user.id ,
          {
            toTeamId: editedUser.data[team].teamId,
            userId: editedUser.user.id,
            date: editedUser.data[team].when }
        );
      }
    };

    let submit1 = makeSubmit('newTeam1');
    let submit2 = makeSubmit('newTeam2');
    let submits = [];
    submit1 && submits.push(submit1);
    submit2 && submits.push(submit2);

    if(submits.length > 0){
      this.$q.all(submits).then(
        (response) => {
          this.state = 'loaded';
          this.editedTeamData = null;
          this.teamData = null;

          if(response[0].data[1]) {
            this.comment = response[0].data[1];
            this.comment && (this.changeTeamInfo = true);
          } else if(response[1] && response[1].data[1]) {
            this.comment = response[1].data[1];
            this.comment && (this.changeTeamInfo = true);
          } else {
            this.changeTeamProcess = false;
          }
        },
        (error) => {
          this.state = 'loaded';
          this.Notes.postNote({type: "error", error: error});
        }
      );
    }
    else{
      this.state = 'loaded';
    }
  }

  submitChangeTeamInfo() {
    this.changeTeamProcess = false;
    this.changeTeamInfo = false;
  }

  cancelChangeTeam() {
    this.editedTeamData = null;
    this.teamData = null;
    this.changeTeamProcess = false;
    this.changeTeamInfo = false;
  }

  startBlockingUser(user) {
    this.blockUserProcess = true;
    this.blockUserValues = angular.fromJson(angular.toJson(user));
    if(this.user.isLocalAdmin) {
      delete this.blockUserValues.canEditAccepted;
      delete this.blockUserValues.isAdmin;
      delete this.blockUserValues.isLocalAdmin;
      delete this.blockUserValues.isIntegrationAdmin;
      delete this.blockUserValues.canViewRates;
      delete this.blockUserValues.canUpdateRates;
      delete this.blockUserValues.canAccess360View;
      delete this.blockUserValues.canAccessFlexitime;
    }
  }

  startEditingBlockedUser(user) {
    this.editBlockedUserProcess = true;
    this.blockedUserValues = angular.fromJson(angular.toJson(user));
    this.blockedUserValues.validFrom = user.blockedAt;
    if(this.user.isLocalAdmin) {
      delete this.blockedUserValues.canEditAccepted;
      delete this.blockedUserValues.isAdmin;
      delete this.blockedUserValues.isLocalAdmin;
      delete this.blockedUserValues.isIntegrationAdmin;
      delete this.blockedUserValues.canUpdateRates;
      delete this.blockedUserValues.canViewRates;
      delete this.blockedUserValues.canAccess360View;
      delete this.blockedUserValues.canAccessFlexitime;
    }
  }

  unblockUser(user) {
    this.Admin.unblockUser(user.id).then(
      () => {
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  editUser(user , process) {
    this.updateUser(user , process);
  }

  blockUser(originalUser , process) {
    let user = angular.copy(originalUser);
    if(moment(originalUser.validFrom).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")){
      user.blockedAt = moment().format();
    } else {
      user.blockedAt = moment(originalUser.validFrom).format();
    }

    delete user.validFrom;
    delete user.country;
    delete user.worknorms;

    this.confirmBlockUser(user , process);
  }

  editBlockedUser(originalUser , process) {
    let user = angular.copy(originalUser);
    user.blockedAt = moment(originalUser.validFrom).format();
    delete user.validFrom;
    delete user.country;
    delete user.worknorms;
    delete user.blockedAtF;

    if (this.user.isLocalAdmin) {
      delete user.isIntegrationAdmin;
    }

    this.updateUser(user , process);
  }

  confirmBlockUser(user , process) {
    this[process] = false;
    this.modalConfig = {
      text: "USERS.BLOCK_CONFIRMATION",
      cancelText: "CANCEL",
      acceptText: "SUBMIT"
    };
    this.bModal.show(this.modalConfig).then(
      () => {
        this.updateUser(user , process);
      },
      () => {
        this.state = 'loaded';
      }
    );
  }

  confirmUnblockUser(user) {
    this.modalConfig = {
      text: "USERS.UNBLOCK_CONFIRMATION",
      warning: "USERS.UNBLOCK_WARNING",
      cancelText: "CANCEL",
      acceptText: "SUBMIT"
    };
    this.bModal.show(this.modalConfig).then(
      () => {
        this.unblockUser(user);
      },
      () => {
        this.state = 'loaded';
      }
    );
  }

  setColWidth(data, index, min = 10) {
    return data.reduce((width, row) => Math.max(width, row[index].length) , min);
  }

  exportActiveUsers() {
    const headers = ['FIRST AND LAST NAME', 'EMAIL', 'COUNTRY', 'TEAM', 'ACTIVE FROM', 'SITE'];
    const data = this.users.map(user => {
      const team = this.teams.find(team => team.id === user.teamId);
      const teamName = team ? team.name : '';
      return [user.fullName, user.emailAddress, user.country, teamName, user.activeFrom || '', user.siteName || ''];
    });
    const workbook = XLSX.utils.book_new();
    const sheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, sheet, "Active users");
    XLSX.utils.sheet_add_aoa(sheet, [headers], { origin: "A1" });
    sheet["!cols"] = headers.map((_, index) => ({wch: this.setColWidth(data, index)}));
    XLSX.writeFile(workbook, `Active users - ${moment().format('YYYY-MM-DD')}.xlsx`, { compression: true });
  }
}
